import commonService from "./common-service";

class ClarificationsService {
    async getClarificationsData() {
        try {
            const response = await commonService.getFromServer(
                "Clarification/Get",
                {}
            );
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async submitClarifications(params) {
        try {
            const response = await commonService.postToServer("Clarification/Submit", params);
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getVerbalOrders() {
        try {
            const response = await commonService.getFromServer(
                "Clarification/GetVerbalOrders",
                {}
            );
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async submitVerbalOrders(params) {
        try {
            const response = await commonService.postToServer("Clarification/SubmitVerbalOrders", params);
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    }
}

export default new ClarificationsService();
